var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCLientYet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 84,
    viewBox: "0 0 81 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty-folder 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exp-3.-G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5193 34.3267H19.3818C18.3892 34.3267 17.4377 34.7207 16.7357 35.4227C16.0349 36.1235 15.6409 37.075 15.6409 38.0675V45.5493H65.5193V34.3267Z",
    fill: "url(#paint0_linear_9599_30239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6409 38.9248H65.5193V41.2479H15.6409V38.9248Z",
    fill: "url(#paint1_linear_9599_30239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5197 33.1789C65.5197 32.1875 65.1256 31.2361 64.4236 30.5341C63.7216 29.8333 62.7701 29.438 61.7788 29.438C57.3134 29.438 49.9576 29.438 46.0197 29.438C44.4149 29.438 42.9896 30.4617 42.4758 31.9818C41.7551 34.1178 40.8411 36.8213 40.8411 36.8213H65.5197V33.1789Z",
    fill: "url(#paint2_linear_9599_30239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6219 46.3183C68.8464 44.8793 68.4299 43.4128 67.4822 42.3055C66.5345 41.1982 65.1504 40.561 63.6927 40.561C52.6932 40.561 28.9885 40.561 17.989 40.561C16.5313 40.561 15.1472 41.1982 14.1995 42.3055C13.2518 43.4128 12.8353 44.8793 13.0598 46.3183C14.3292 54.4385 16.6136 69.0603 17.7359 76.2453C18.1162 78.6744 20.2074 80.4638 22.6651 80.4638H59.0166C61.4743 80.4638 63.5655 78.6744 63.9458 76.2453C65.0681 69.0603 67.3525 54.4385 68.6219 46.3183Z",
    fill: "url(#paint3_linear_9599_30239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0598 46.3183L13.6995 50.4083C13.4738 48.9681 13.9688 47.5016 14.9165 46.3943C15.8642 45.287 17.2483 44.6498 18.706 44.6498H62.9757C64.4334 44.6498 65.8175 45.287 66.7652 46.3943C67.7129 47.5016 68.2079 48.9681 67.9822 50.4083L68.6219 46.3183C68.8464 44.8793 68.4299 43.4128 67.4822 42.3055C66.5345 41.1982 65.1504 40.561 63.6927 40.561C52.6932 40.561 28.9885 40.561 17.989 40.561C16.5313 40.561 15.1472 41.1982 14.1995 42.3055C13.2518 43.4128 12.8353 44.8793 13.0598 46.3183Z",
    fill: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9931 70.2991C37.9931 68.9225 36.8771 67.8052 35.4992 67.8052C32.7322 67.8052 28.2917 67.8052 25.5235 67.8052C24.1468 67.8052 23.0295 68.9225 23.0295 70.2991V72.793C23.0295 74.1709 24.1468 75.2869 25.5235 75.2869H35.4992C36.8771 75.2869 37.9931 74.1709 37.9931 72.793C37.9931 71.9912 37.9931 71.1021 37.9931 70.2991Z",
    fill: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7046 8.3121C42.0538 0.671963 53.7466 1.16576 46.9394 8.3121H40.7046Z",
    fill: "url(#paint4_linear_9599_30239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7046 10.2468C42.0538 17.8857 53.7466 17.3932 46.9394 10.2468H40.7046Z",
    fill: "url(#paint5_linear_9599_30239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5932 10.5379H48.9428C49.6311 10.5379 50.1898 9.97923 50.1898 9.29091C50.1898 8.60258 49.6311 8.04395 48.9428 8.04395H40.5932C39.9061 8.04395 39.3462 8.60258 39.3462 9.29091C39.3462 9.97923 39.9061 10.5379 40.5932 10.5379Z",
    fill: "url(#paint6_linear_9599_30239)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5031 32.4612C31.8056 31.6535 32.2669 30.8894 32.8755 30.191C33.1201 29.9104 33.0895 29.484 32.8104 29.2405C32.5298 28.9959 32.1032 29.0252 31.8599 29.3056C31.1409 30.13 30.6003 31.0342 30.2413 31.9877C30.1101 32.3357 30.2875 32.7243 30.6354 32.8554C30.9832 32.9852 31.372 32.8092 31.5031 32.4612Z",
    fill: "#738BAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1867 28.2814C36.1828 27.6804 37.3499 27.1891 38.6769 26.8312C39.0352 26.7353 39.2488 26.3656 39.1513 26.0061C39.0554 25.6478 38.6857 25.4342 38.326 25.5303C36.8683 25.9234 35.5871 26.4677 34.4912 27.1261C34.1732 27.3178 34.0694 27.7322 34.2613 28.0515C34.453 28.3695 34.8674 28.4733 35.1867 28.2814Z",
    fill: "#738BAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9294 26.2692C43.5216 26.1285 44.9641 25.9168 46.2684 25.6446C46.6328 25.5695 46.8663 25.2129 46.7912 24.8484C46.7148 24.4841 46.3582 24.2506 45.9937 24.3257C44.7356 24.5876 43.3449 24.7908 41.8119 24.9259C41.4406 24.9597 41.1667 25.2861 41.199 25.6563C41.2328 26.0276 41.5593 26.3015 41.9294 26.2692Z",
    fill: "#738BAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7905 24.6621C51.294 24.1154 52.5364 23.4683 53.5538 22.7559C53.8585 22.5418 53.9326 22.1214 53.7201 21.8177C53.506 21.513 53.0856 21.4389 52.7806 21.6516C51.8491 22.3048 50.708 22.8956 49.3309 23.397C48.9805 23.5243 48.801 23.9103 48.9281 24.2594C49.0555 24.6098 49.4415 24.7893 49.7905 24.6621Z",
    fill: "#738BAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9603 20.462C56.9619 19.1159 57.4431 17.6767 57.5363 16.2781C57.5611 15.9067 57.2802 15.5857 56.9088 15.5608C56.5387 15.5358 56.2164 15.8169 56.1929 16.1881C56.1152 17.3492 55.7107 18.541 54.88 19.6569C54.6575 19.9557 54.7203 20.3782 55.0175 20.5996C55.3164 20.8221 55.7391 20.7607 55.9603 20.462Z",
    fill: "#738BAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4642 11.7533C55.7069 10.4389 54.6149 9.39669 53.4022 8.82362C53.0663 8.66595 52.664 8.81006 52.505 9.14621C52.3473 9.48214 52.4914 9.88443 52.8274 10.0421C53.8104 10.5055 54.6832 11.3612 55.297 12.4262C55.4824 12.748 55.8953 12.8588 56.2171 12.6734C56.5388 12.4879 56.6497 12.075 56.4642 11.7533Z",
    fill: "#738BAB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9599_30239",
    x1: 15.6409,
    y1: 37.4939,
    x2: 65.5193,
    y2: 37.4939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9599_30239",
    x1: 15.6409,
    y1: 40.0857,
    x2: 65.5193,
    y2: 40.0857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9599_30239",
    x1: 15.9018,
    y1: 37.4946,
    x2: 65.7803,
    y2: 37.4946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9599_30239",
    x1: 13.0012,
    y1: 60.5124,
    x2: 68.6818,
    y2: 60.5124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9599_30239",
    x1: 40.7046,
    y1: 5.53885,
    x2: 49.053,
    y2: 5.53885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9599_30239",
    x1: 40.7046,
    y1: 13.0201,
    x2: 49.053,
    y2: 13.0201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9599_30239",
    x1: 39.3474,
    y1: 9.29091,
    x2: 50.1898,
    y2: 9.29091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCLientYet);
export default __webpack_public_path__ + "static/media/noCLientYet.acfb39f8ba94e2072d375a196dbc7486.svg";
export { ForwardRef as ReactComponent };